// Template Generated by DataExtraction.py at 1716507313

import EnglishMat2 from "../../Forms/KYC2/English_Mat-2.png";
import EnglishMat2Labels from "../../Labels/KYC2/English_Mat-2.json";
import FrenchMat2 from "../../Forms/KYC2/French_Mat-2.png";
import FrenchMat2Labels from "../../Labels/KYC2/French_Mat-2.json";
import {
    drawTextOnLabel,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    signatureLabel,
    signatureTab,
} from "../../PDFGenerationUtils";
import { POSSIBLE_SIGNERS } from "../../../Utils/PlanUtils";

import moment from "moment/moment";
import { t } from "i18next";
import { displayCurrency } from "../../../Utils/FormattingUtils";
import {
    calculateTotalMonthlyExpenses,
    calculateMonthlyDisposableIncome,
    calculateMonthlyIncomeGross,
    calculateMonthlyIncomeNet,
    calculateYearlyIncomeGross,
    calculateTotalMonthlyExpensesAfterMat,
    calculateMonthlyDisposableIncomeAfterMat,
    calculateMonthlyIncomeGrossAfterMat,
    calculateMonthlyIncomeNetAfterMat,
    calculateMaxEducationSavingsPlans,
} from "../../../Utils/KYCUtils";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? FrenchMat2Labels : EnglishMat2Labels;
    const formImage = isFrench ? FrenchMat2 : EnglishMat2;

    function fillCheckbox(value, label) {
        drawTextOnLabel(doc, value ? t("Yes") : t("No"), label, labels);
    }

    function drawText(value, label, colorOverride = null, bold = false) {
        drawTextOnLabel(doc, value, label, labels, colorOverride, bold);
    }

    // add image
    doc.addImage(
        formImage,
        standardFormFormat,
        labels["image"]["x"],
        labels["image"]["y"],
        labels["image"]["width"],
        labels["image"]["height"],
        null,
        standardFormCompression,
    );

    const subscriber = data.subscriber;
    const jointSubscriber = data.jointSubscriber;
    const common = data.common;
    const kyc = data.knowYourClient;
    const plan = data.plan;

    const subscriber2Include = common.subscriber2Include;
    const planTypeID = plan.planTypeID;

    const {
        monthlyMaximumEducationSavingsPlan,
        monthlyMaximumEducationSavingsPlanGroup,
    } = calculateMaxEducationSavingsPlans(subscriber, jointSubscriber, kyc);

    const now = moment().format("yyyy-MM-DD");

    // Expenses
    drawText(
        displayCurrency(kyc.paymentOnLoansAndDebts, i18n.language),
        "paymentsOnLoansAndDebts",
    );
    drawText(
        displayCurrency(kyc.morgageCondoFeesRent, i18n.language),
        "mortgage",
    );
    drawText(displayCurrency(kyc.groceries, i18n.language), "groceries");
    drawText(displayCurrency(kyc.clothing, i18n.language), "clothing");
    drawText(displayCurrency(kyc.insurance, i18n.language), "insurance");
    drawText(
        displayCurrency(kyc.transportation, i18n.language),
        "transportation",
    );
    drawText(displayCurrency(kyc.childCare, i18n.language), "childCare");
    drawText(
        displayCurrency(kyc.miscellaneous, i18n.language),
        "miscellaneous",
    );
    drawText(
        displayCurrency(kyc.otherContractualObligations, i18n.language),
        "otherContractualObligations",
    );
    drawText(displayCurrency(kyc.utilities, i18n.language), "utilities");
    drawText(kyc.vehicles, "vehicles");

    drawText(
        displayCurrency(calculateTotalMonthlyExpenses(kyc), i18n.language),
        "totalExpenses",
    );
    drawText(
        displayCurrency(
            calculateMonthlyDisposableIncome(subscriber, jointSubscriber, kyc),
            i18n.language,
        ),
        "disposableIncome",
        calculateMonthlyDisposableIncome(subscriber, jointSubscriber, kyc) < 0
            ? { r: 255, g: 0, b: 0, a: 255 }
            : null,
    );

    // Income
    drawText(
        displayCurrency(subscriber.monthlyIncomeGross, i18n.language),
        "s1Gross",
    );
    drawText(
        displayCurrency(subscriber.monthlyIncomeNet, i18n.language),
        "s1Net",
    );
    if (subscriber2Include) {
        drawText(
            displayCurrency(jointSubscriber.monthlyIncomeGross, i18n.language),
            "s2Gross",
        );
        drawText(
            displayCurrency(jointSubscriber.monthlyIncomeNet, i18n.language),
            "s2Net",
        );
    }
    drawText(
        displayCurrency(kyc.otherMonthlyIncomeGross, i18n.language),
        "otherGross",
    );
    drawText(
        displayCurrency(kyc.otherMonthlyIncomeNet, i18n.language),
        "otherNet",
    );
    drawText(
        displayCurrency(kyc.ccbMonthlyIncomeGross, i18n.language),
        "ccbGross",
    );
    drawText(
        displayCurrency(kyc.ccbMonthlyIncomeGross, i18n.language),
        "ccbNet",
    ); // Assumption ccb net same as gross unless mapped

    drawText(
        displayCurrency(
            calculateMonthlyIncomeGross(subscriber, jointSubscriber, kyc),
            i18n.language,
        ),
        "totalGross",
    );
    drawText(
        displayCurrency(
            calculateMonthlyIncomeNet(subscriber, jointSubscriber, kyc),
            i18n.language,
        ),
        "totalNet",
    );
    drawText(
        displayCurrency(
            calculateYearlyIncomeGross(subscriber, jointSubscriber, kyc),
            i18n.language,
        ),
        "yearlyIncomeGross",
    );


    if (planTypeID === 0) {
        // GROUP
        drawText(
            "N/A",
            "maximumEsp",
            null,
            true,
        );
        drawText(
            displayCurrency(monthlyMaximumEducationSavingsPlanGroup, i18n.language),
            "maximumEspGroup",
            null,
            true,
        );
    } else if (planTypeID === 1) {
        // SI
        drawText(
            "N/A",
            "maximumEsp",
            null,
            true,
        );
        drawText(
            "N/A",
            "maximumEspGroup",
            null,
            true,
        );
    } else if (planTypeID === 2) {
        // ACHIEVERS
        drawText(
            displayCurrency(monthlyMaximumEducationSavingsPlan),
            "maximumEsp",
            null,
            true,
        );
        drawText(
            "N/A",
            "maximumEspGroup",
            null,
            true,
        );
    }

    // Affordability
    if (planTypeID === 0) {
        // Group
        drawText("(H)", "affordabilityGroup", null, true);
    } else if (planTypeID === 2) {
        // Achievers
        drawText("(H)", "affordabilityAchievers", null, true);
    }

    // After Mat Leave Expenses
    drawText(
        displayCurrency(kyc.paymentOnLoansAndDebtsAfterMat, i18n.language),
        "paymentsOnLoansAndDebtsAfterMat",
    );
    drawText(
        displayCurrency(kyc.morgageCondoFeesRentAfterMat, i18n.language),
        "mortgageAfterMat",
    );
    drawText(
        displayCurrency(kyc.groceriesAfterMat, i18n.language),
        "groceriesAfterMat",
    );
    drawText(
        displayCurrency(kyc.clothingAfterMat, i18n.language),
        "clothingAfterMat",
    );
    drawText(
        displayCurrency(kyc.insuranceAfterMat, i18n.language),
        "insuranceAfterMat",
    );
    drawText(
        displayCurrency(kyc.transportationAfterMat, i18n.language),
        "transportationAfterMat",
    );
    drawText(
        displayCurrency(kyc.childCareAfterMat, i18n.language),
        "childCareAfterMat",
    );
    drawText(
        displayCurrency(kyc.miscellaneousAfterMat, i18n.language),
        "miscellaneousAfterMat",
    );
    drawText(
        displayCurrency(kyc.otherContractualObligationsAfterMat, i18n.language),
        "otherContractualObligationsAfterMat",
    );
    drawText(
        displayCurrency(kyc.utilitiesAfterMat, i18n.language),
        "utilitiesAfterMat",
    );
    drawText(kyc.vehiclesAfterMat, "vehiclesAfterMat");

    drawText(
        displayCurrency(
            calculateTotalMonthlyExpensesAfterMat(kyc),
            i18n.language,
        ),
        "totalExpensesAfterMat",
    );
    drawText(
        displayCurrency(
            calculateMonthlyDisposableIncomeAfterMat(
                subscriber,
                jointSubscriber,
                kyc,
            ),
            i18n.language,
        ),
        "disposableIncomeAfterMat",
        calculateMonthlyDisposableIncomeAfterMat(
            subscriber,
            jointSubscriber,
            kyc,
        ) < 0
            ? { r: 255, g: 0, b: 0, a: 255 }
            : null,
    );

    // After Mat Leave Income
    drawText(
        displayCurrency(subscriber.monthlyIncomeGrossAfterMat, i18n.language),
        "s1GrossAfterMat",
    );
    drawText(
        displayCurrency(subscriber.monthlyIncomeNetAfterMat, i18n.language),
        "s1NetAfterMat",
    );
    if (subscriber2Include) {
        drawText(
            displayCurrency(
                jointSubscriber.monthlyIncomeGrossAfterMat,
                i18n.language,
            ),
            "s2GrossAfterMat",
        );
        drawText(
            displayCurrency(
                jointSubscriber.monthlyIncomeNetAfterMat,
                i18n.language,
            ),
            "s2NetAfterMat",
        );
    }
    drawText(
        displayCurrency(kyc.otherMonthlyIncomeGrossAfterMat, i18n.language),
        "otherGrossAfterMat",
    );
    drawText(
        displayCurrency(kyc.otherMonthlyIncomeNetAfterMat, i18n.language),
        "otherNetAfterMat",
    );
    drawText(
        displayCurrency(kyc.ccbMonthlyIncomeGrossAfterMat, i18n.language),
        "ccbGrossAfterMat",
    );
    drawText(
        displayCurrency(kyc.ccbMonthlyIncomeGrossAfterMat, i18n.language),
        "ccbNetAfterMat",
    );

    drawText(
        displayCurrency(
            calculateMonthlyIncomeGrossAfterMat(
                subscriber,
                jointSubscriber,
                kyc,
            ),
            i18n.language,
        ),
        "totalGrossAfterMat",
    );
    drawText(
        displayCurrency(
            calculateMonthlyIncomeNetAfterMat(subscriber, jointSubscriber, kyc),
            i18n.language,
        ),
        "totalNetAfterMat",
    );

    // Signatures
    drawText(now, "drDate");
    drawText(now, "s1Date");
    if (subscriber2Include) {
        drawText(now, "s2Date");
    }
};

//Returns the signature definitions for the document
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? FrenchMat2Labels : EnglishMat2Labels;
    const DRRecipientId = POSSIBLE_SIGNERS["Dealing Representative"];
    const subscriberRecipientId = POSSIBLE_SIGNERS["Subscriber"];
    const jointSubscriberRecipientId = POSSIBLE_SIGNERS["Joint Subscriber"];
    let signers = [];

    const subscriber2Include = state.common.subscriber2Include;

    // s1Signature
    signers.push({
        [subscriberRecipientId]: [
            signatureTab(
                subscriberRecipientId,
                documentId,
                pageNumber,
                signatureLabel("s1Signature", labels),
            ),
        ],
    });

    // drSignature
    signers.push({
        [DRRecipientId]: [
            signatureTab(
                DRRecipientId,
                documentId,
                pageNumber,
                signatureLabel("drSignature", labels),
            ),
        ],
    });

    if (subscriber2Include) {
        // s2Signature
        signers.push({
            [jointSubscriberRecipientId]: [
                signatureTab(
                    jointSubscriberRecipientId,
                    documentId,
                    pageNumber,
                    signatureLabel("s2Signature", labels),
                ),
            ],
        });
    }

    return signers;
};

export default {
    generate,
    signatureDefinitions,
};
